// OnboardingHint — kartu perkenalan singkat sekali per peran (localStorage).
// Muncul di atas konten utama AppShell saat login pertama dengan peran tersebut.
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles, X } from 'lucide-react';

const ROLE_KEY = {
  bendahara: 'onboardingBendahara',
  guru: 'onboardingGuru',
  orangtua: 'onboardingOrangtua',
};

export default function OnboardingHint({ role }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!role || !ROLE_KEY[role]) return;
    try {
      if (!localStorage.getItem(`mtsr_onboard_${role}`)) setShow(true);
    } catch { setShow(false); }
  }, [role]);

  if (!show || !ROLE_KEY[role]) return null;
  const k = ROLE_KEY[role];

  const dismiss = () => {
    try { localStorage.setItem(`mtsr_onboard_${role}`, '1'); } catch { /* abaikan */ }
    setShow(false);
  };

  return (
    <div className="mb-4 sm:mb-6 flex items-start gap-3 rounded-2xl border border-brand/25 bg-gradient-to-r from-brand-light to-card p-4 shadow-sm" data-testid="onboarding-hint">
      <span className="h-9 w-9 shrink-0 rounded-xl bg-brand text-white flex items-center justify-center">
        <Sparkles className="h-4 w-4" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-foreground">{t(`${k}T`)}</p>
        <p className="mt-0.5 text-[13px] leading-relaxed text-muted-foreground">{t(`${k}B`)}</p>
      </div>
      <button
        onClick={dismiss}
        className="h-8 w-8 shrink-0 flex items-center justify-center rounded-lg text-muted-foreground hover:bg-muted hover:text-muted-foreground"
        aria-label={t('tutupModal')}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
